import { createSelector } from '@ngrx/store';
import { authFeature } from './auth.reducer';

export const { selectAuthState, selectUser, selectIsAuthenticated, selectAuthInfo } = authFeature;

export const selectIsInstructor = createSelector(selectAuthState, (state) => {
  if (typeof state.isAuthenticated === 'boolean') {
    return state.isAuthenticated && state.authInfo?.is_instructor;
  }

  return;
});
// export const selectUserId = createSelector(selectUser, (user) => user?.id || '');
export const selectUserId = createSelector(selectAuthInfo, (user) => {
  return user?.id || 0;
});
export const selectAuthCart = createSelector(selectAuthInfo, (user) => user?.cart);
export const selectCartCount = createSelector(selectAuthInfo, (user) => user?.cart_item_count);
